export default __webpack_public_path__ + "img/bg_membership1-ea0636cca80c890b381ea0b2d16e9145.png";